module.exports = __webpack_public_path__ + "static/media/walk_disabled_person.6ed68854.svg";